<span *ngIf="column.iconConfig.defaultIcon else multipleIcons">
  <mat-icon *ngIf="column.isVisible == null || column.isVisible(rowData)"
            class="action-button"
            (click)="onClick($event)">
    {{column.iconConfig.defaultIcon}}
  </mat-icon>
</span>

<ng-template #multipleIcons>
  <mat-icon
    *ngIf="column.isVisible == null || column.isVisible(rowData)"
    class="action-button"
    [ngClass]="getIcon().cssClass"
    (click)="onClick($event)">
    {{getIcon().icon}}
  </mat-icon>
</ng-template>
